export default {
  // 防汛区信息
  GET_PREVENTION_AREAINFO: 'GET_PREVENTION_AREAINFO',
  SAVE_PREVENTION_AREAINFO: 'SAVE_PREVENTION_AREAINFO',
  DELETE_PREVENTION_AREAINFO: 'DELETE_PREVENTION_AREAINFO',
  // 历史山洪调查信息
  GET_FLOODINFO: 'GET_FLOODINFO',
  SAVE_FLOODINFO: 'SAVE_FLOODINFO',
  DELETE_FLOODINFO: 'DELETE_FLOODINFO',
  // 水库
  GET_RESERVOIR: 'GET_RESERVOIR',
  SAVE_RESERVOIR: 'SAVE_RESERVOIR',
  DELETE_RESERVOIR: 'DELETE_RESERVOIR',
  // 水闸
  GET_SLUICE: 'GET_SLUICE',
  SAVE_SLUICE: 'SAVE_SLUICE',
  DELETE_SLUICE: 'DELETE_SLUICE',
  // 堤防
  GET_DIKE: 'GET_DIKE',
  SAVE_DIKE: 'SAVE_DIKE',
  DELETE_DIKE: 'DELETE_DIKE',
  // 塘（堰）坝
  GET_DAM: 'GET_DAM',
  SAVE_DAM: 'SAVE_DAM',
  DELETE_DAM: 'DELETE_DAM',
  // 简易水位/雨量站
  GET_SIMPLERAIN_ANDWATER: 'GET_SIMPLERAIN_ANDWATER',
  SAVE_SIMPLERAIN_ANDWATER: 'SAVE_SIMPLERAIN_ANDWATER',
  DELETE_SIMPLERAIN_ANDWATER: 'DELETE_SIMPLERAIN_ANDWATER',
  // 自动遥测站
  GET_STATIONINFO: 'GET_STATIONINFO',
  SAVE_STATIONINFO: 'SAVE_STATIONINFO',
  DELETE_STATIONINFO: 'DELETE_STATIONINFO',
  GET_SITE_ALL: 'GET_SITE_ALL',
  GET_SITE_MAIN: 'GET_SITE_MAIN',
  EXPORT_STATIONINFO: 'EXPORT_STATIONINFO',
  // 预案信息
  GET_PLAN: 'GET_PLAN',
  SAVE_PLAN: 'SAVE_PLAN',
  DELETE_PLAN: 'DELETE_PLAN',
  // 预警指标信息
  GET_WARNINDEX: 'GET_WARNINDEX',
  SAVE_WARNINDEX: 'SAVE_WARNINDEX',
  DELETE_WARNINDEX: 'DELETE_WARNINDEX',
  // 行政区划三级联动
  GET_MUTIRANKS_ADCD: 'GET_MUTIRANKS_ADCD',
  // 行政区划基本信息
  getAdcd: 'getAdcd',
  getAdcdBaseInfo: 'getAdcdBaseInfo',
  upAdcd: 'upAdcd',
  delAdcd: 'delAdcd',
  // 库容区线
  GET_STORAGE_CURVE_STATION: 'GET_STORAGE_CURVE_STATION',
  GET_STORAGE_CURVE: 'GET_STORAGE_CURVE',
  SAVE_STORAGE_CURVE: 'SAVE_STORAGE_CURVE'
}
